import { Form, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { loadAllCompany } from "../../../redux/rtk/features/crm/company/companySlice";
import { loadAllContact } from "../../../redux/rtk/features/crm/contact/contactSlice";
import { loadAllOpportunity } from "../../../redux/rtk/features/crm/opportunity/opportunitySlice";
import {
	deleteManyQuote,
	loadAllQuotePaginated,
} from "../../../redux/rtk/features/crm/quote/quoteSlice";
import { loadAllQuoteStage } from "../../../redux/rtk/features/crm/quoteStage/quoteStageSlice";
import { loadAllStaff } from "../../../redux/rtk/features/user/userSlice";
import ViewBtn from "../../Buttons/ViewBtn";
import UserPrivateComponent from "../../PrivateRoutes/UserPrivateComponent";
import CreateDrawer from "../CommonUi/CreateDrawer";
import CrmSearch from "../CommonUi/CrmSearch";
import TableComponent from "../CommonUi/TableComponent";
import CreateQuoteForm from "./CreateQuoteForm";

const columns = [
	{
		title: "Name",
		key: "quoteName",
		render: ({ quoteName, id }) =>
			id ? <Link to={`/admin/quote/${id}`}>{quoteName}</Link> : "-",
		sorter: (a, b) => a.quoteName.localeCompare(b.quoteName),
	},
	{
		title: "Owner",
		dataIndex: "quoteOwner",
		render: (quoteOwner, item) => (
			<Link to={`/admin/setup/staffs/${item?.quoteOwnerId}`}>
				{quoteOwner.firstName} {quoteOwner.lastName}
			</Link>
		),
	},
	{
		title: "Quotation Date",
		dataIndex: "quotationDate",
		render: (date) => moment(date).format("MMMM Do YYYY"),
	},
	{
		title: "Expiration Date",
		dataIndex: "expirationDate",
		render: (date) => moment(date).format("MMMM Do YYYY"),
	},
	{
		title: "Total Amount",
		dataIndex: "totalAmount",
		key: "totalAmount",
		render: (total) => (total ? total : "-"),
	},
	{
		title: "Company",
		dataIndex: "company",
		render: (company, item) => (
			<Link to={`/admin/company/${item?.companyId}`}>
				{company?.companyName}
			</Link>
		),
	},

	{
		title: "Create Date",
		dataIndex: "createdAt",
		render: (date) => moment(date).format("MMMM Do YYYY"),
	},
	{
		title: "Action",
		dataIndex: "id",
		key: "action",
		render: (id) => (
			<div className='flex justify-start'>
				<ViewBtn path={`/admin/quote/${id}`} />
			</div>
		),
	},
];

const Quotes = () => {
	const dispatch = useDispatch();
	// Drawer state
	const [open, setOpen] = useState(false);
	const onClose = () => {
		setOpen(false);
	};

	// filter
	const [isFilter, setFilter] = useState(false);
	const filterToggle = () => {
		setFilter((prev) => !prev);
	};
	const { Option } = Select;
	const quoteStage = useSelector((state) => state.quoteStage.list) || [];
	const company = useSelector((state) => state.company.list) || [];
	const contact = useSelector((state) => state.contact.list) || [];
	const opportunity = useSelector((state) => state.opportunity.list) || [];
	const quoteOwner = useSelector((state) => state.users.list) || [];
	const { list, loading, total } = useSelector((state) => state.quote);

	const [form] = Form.useForm();

	const onFinish = async (values) => {
		dispatch(
			loadAllQuotePaginated({
				...values,
			})
		);
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
	};

	useEffect(() => {
		dispatch(loadAllContact());
		dispatch(loadAllCompany());
		dispatch(loadAllOpportunity());
		dispatch(loadAllQuoteStage());
		dispatch(loadAllStaff({ status: true }));
		dispatch(loadAllQuotePaginated({ status: true }));
	}, [dispatch]);

	return (
		<div className='container'>
			<div className='bg-white dark:bg-DTableBg flex flex-col md:flex-row justify-between items-center gap-3 p-3 px-6 border'>
				<div className='flex justify-end items-center gap-5'>
					<button
						onClick={filterToggle}
						className={`hidden md:block ${
							isFilter ? "bg-transparent border border-red-600" : "infineneBtn"
						}  px-5 py-2 rounded cursor-pointer`}
						type='submit'>
						{isFilter ? (
							<span className='flex justify-center dark:text-white items-center gap-2'>
								<AiOutlineClose /> Close
							</span>
						) : (
							<span className='text-white'>Filter</span>
						)}
					</button>
					{!isFilter ? (
						<CrmSearch paginatedThunk={loadAllQuotePaginated} />
					) : (
						<div className='flex text-md'>
							<Form
								className='flex flex-wrap justify-center gap-2 md:items-center'
								form={form}
								onFinish={onFinish}
								onFinishFailed={onFinishFailed}
								layout='inline'
								initialValues={{
									status: ["true"],
								}}>
								<Form.Item name='quoteOwner' className='w-full md:w-[180px]'>
									<Select
										mode='multiple'
										style={{ width: "100%" }}
										placeholder='Select Owner'
										maxTagCount={0}
										maxTagPlaceholder={<div className='w-[150px]'>Owner</div>}>
										{quoteOwner?.map((item) => (
											<Option key={item.id} value={item.id}>
												{item?.firstName} {item?.lastName}
											</Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item name='quoteStage' className='w-full md:w-[180px]'>
									<Select
										mode='multiple'
										style={{ width: "100%" }}
										placeholder='Select Stage'
										maxTagCount={0}
										maxTagPlaceholder={<div className='w-[150px]'>Stage</div>}>
										{quoteStage?.map((item) => (
											<Option key={item.id} value={item.id}>
												{item.quoteStageName}
											</Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item name='contact' className='w-full md:w-[180px]'>
									<Select
										mode='multiple'
										style={{ width: "100%" }}
										placeholder='Select contact'
										maxTagCount={0}
										maxTagPlaceholder={
											<div className='w-[150px]'>Contact</div>
										}>
										{contact?.map((item) => (
											<Option key={item.id} value={item.id}>
												{item?.firstName} {item?.lastName}
											</Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item name='company' className='w-full md:w-[180px]'>
									<Select
										mode='multiple'
										style={{ width: "100%" }}
										placeholder='Select Company'
										maxTagCount={0}
										maxTagPlaceholder={
											<div className='w-[150px]'>Company</div>
										}>
										{company?.map((item) => (
											<Option key={item.id} value={item.id}>
												{item.companyName}
											</Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item name='opportunity' className='w-full md:w-[180px]'>
									<Select
										mode='multiple'
										style={{ width: "100%" }}
										placeholder='Select Opportunity'
										maxTagCount={0}
										maxTagPlaceholder={
											<div className='w-[150px]'>Opportunity</div>
										}>
										{opportunity?.map((item) => (
											<Option key={item.id} value={item.id}>
												{item.opportunityName}
											</Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item name='status' className='w-full md:w-[180px]'>
									<Select
										mode='multiple'
										style={{ width: "100%" }}
										placeholder='Please select'
										defaultValue={["true"]}>
										<Option value='true'>True</Option>
										<Option value='false'>False</Option>
									</Select>
								</Form.Item>
								<Form.Item>
									<div className='w-full md:w-[180px] flex justify-start'>
										<button
											className='infineneBtn text-white px-5 py-2 rounded cursor-pointer'
											type='submit'>
											Filter
										</button>
										<button
											onClick={filterToggle}
											className='block md:hidden  px-5 py-2 rounded cursor-pointer ml-2 text-rose-700 transition-colors duration-150 border border-rose-500 focus:shadow-outline hover:bg-rose-500 hover:text-rose-100'>
											Cancel
										</button>
									</div>
								</Form.Item>
							</Form>
						</div>
					)}
				</div>
				{!isFilter && (
					<UserPrivateComponent permission='create-quote'>
						<button
							onClick={() => setOpen(true)}
							className='py-2 px-3 border infineneBtn text-white rounded cursor-pointer flex items-center gap-2'>
							<AiOutlinePlus /> Create Quote
						</button>
					</UserPrivateComponent>
				)}
			</div>
			<UserPrivateComponent permission='readAll-quote'>
				<TableComponent
					list={list}
					total={total}
					loading={loading}
					columns={columns}
					paginatedThunk={loadAllQuotePaginated}
					deleteManyThunk={deleteManyQuote}
					csvFileName={"Opportunity-List"}
				/>
			</UserPrivateComponent>

			<UserPrivateComponent permission='create-quote'>
				<CreateDrawer onClose={onClose} open={open} title={"Quote"}>
					<CreateQuoteForm onClose={onClose} open={open} />
				</CreateDrawer>
			</UserPrivateComponent>
		</div>
	);
};
export default Quotes;
